"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UploadButton = void 0;
var core_1 = require("@material-ui/core");
var react_1 = __importDefault(require("react"));
var react_intl_1 = require("react-intl");
var UploadButton = function (props) {
    var upload = props.upload;
    return (react_1.default.createElement(core_1.Link, { onClick: upload },
        react_1.default.createElement(react_intl_1.FormattedMessage, { id: "ttable.upload", defaultMessage: "\u0412\u044B\u0433\u0440\u0443\u0437\u0438\u0442\u044C \u0432 \u0444\u0430\u0439\u043B" })));
};
exports.UploadButton = UploadButton;
